const EPS = 1e-6;

function finitePositive(value) {
  return Number.isFinite(Number(value)) && Number(value) > 0;
}

function boxesOverlap(a, b) {
  return (
    a.x < b.x + b.dx - EPS && a.x + a.dx > b.x + EPS &&
    a.y < b.y + b.dy - EPS && a.y + a.dy > b.y + EPS &&
    a.z < b.z + b.dz - EPS && a.z + a.dz > b.z + EPS
  );
}

export function palletAxisTolerance(pallet, axis) {
  const tolerance = Math.max(0, Number(pallet?.tolerance ?? 2) || 0);
  if (axis === "x") return pallet?.tolerance_x === true ? tolerance : 0;
  if (axis === "y") return pallet?.tolerance_y === true ? tolerance : 0;
  // Legacy plans historically had the Z tolerance enabled even before axis flags existed.
  if (axis === "z") return pallet?.tolerance_z === false ? 0 : tolerance;
  return 0;
}

export function palletAxisLimit(pallet, axis, baseSize) {
  return Number(baseSize || 0) + palletAxisTolerance(pallet, axis);
}

/**
 * Final guard for manual pallet edits.
 * Every enabled axis uses the pallet's configured tolerance. Legacy plans keep
 * the historical Z tolerance, while X/Y remain strict unless explicitly enabled.
 */
export function validatePalletGeometry(pallet, fallbackL, fallbackW, fallbackH) {
  const L = Number(pallet?.L || fallbackL || 0);
  const W = Number(pallet?.W || fallbackW || 0);
  const H = Number(pallet?.H || fallbackH || 0);
  const maxX = palletAxisLimit(pallet, "x", L);
  const maxY = palletAxisLimit(pallet, "y", W);
  const maxZ = palletAxisLimit(pallet, "z", H);
  const boxes = Array.isArray(pallet?.boxes) ? pallet.boxes : [];

  if (!(L > 0 && W > 0 && H > 0)) {
    return { valid: false, reason: "invalid_pallet_dimensions" };
  }

  for (let i = 0; i < boxes.length; i += 1) {
    const b = boxes[i];
    const nums = [b.x, b.y, b.z, b.dx, b.dy, b.dz].map(Number);
    if (!nums.every(Number.isFinite) || !finitePositive(b.dx) || !finitePositive(b.dy) || !finitePositive(b.dz)) {
      return { valid: false, reason: "invalid_box_dimensions", index: i };
    }
    if (
      Number(b.x) < -EPS || Number(b.y) < -EPS || Number(b.z) < -EPS ||
      Number(b.x) + Number(b.dx) > maxX + EPS ||
      Number(b.y) + Number(b.dy) > maxY + EPS ||
      Number(b.z) + Number(b.dz) > maxZ + EPS
    ) {
      return { valid: false, reason: "outside_pallet", index: i };
    }
  }

  for (let i = 0; i < boxes.length; i += 1) {
    for (let j = i + 1; j < boxes.length; j += 1) {
      if (boxesOverlap(boxes[i], boxes[j])) {
        return { valid: false, reason: "overlap", index: i, otherIndex: j };
      }
    }
  }

  return { valid: true };
}

export function geometryErrorMessage(result) {
  if (!result || result.valid) return "";
  if (result.reason === "outside_pallet") return `Kutu #${Number(result.index) + 1} palet sınırının dışına çıkamaz.`;
  if (result.reason === "overlap") return `Kutu #${Number(result.index) + 1} ile #${Number(result.otherIndex) + 1} iç içe giremez.`;
  if (result.reason === "invalid_box_dimensions") return `Kutu #${Number(result.index) + 1} geçersiz boyut veya konuma sahip.`;
  return "Palet geometrisi geçersiz. Değişiklik uygulanmadı.";
}
